import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUsername, initKeycloak } from "./keycloak";
import { setupAxios } from "../services/axios/config";
import { setAuth } from "../redux/features/auth/authSlice";
import { setUser } from "../redux/features/user";
import { getTenant, removeTenant } from "../utils/tenant";
import { initI18n } from "../i18n";

export default function AuthGate({ tenant, children }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const savedConfig = getTenant();
    const tokenExpiration = Number(localStorage.getItem("token-exp-tm"));
    const now = Date.now();

    if (tokenExpiration && now > tokenExpiration) {
      removeTenant();
      localStorage.removeItem("token-exp-tm");
      navigate("/select-tenant");
      return;
    }

    if (!savedConfig) {
      navigate("/select-tenant");
      return;
    }

    initKeycloak({
      tenant,
      onSessionLost: () => {
        dispatch(setAuth({ authenticated: false, username: "" }));
        dispatch(setUser({}));
        navigate("/select-tenant");
      },
    })
      .then(async ({ authenticated }) => {
        if (!authenticated) {
          removeTenant();
          navigate("/select-tenant");
          return;
        }

        setupAxios();
        dispatch(
          setAuth({
            authenticated,
            username: getUsername(),
          }),
        );
        await initI18n();
        setReady(true);
      })
      .catch((error) => {
        console.error("Keycloak setup error:", error);
        removeTenant();
        navigate("/select-tenant");
      });
  }, [tenant]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!ready) return null;

  return children;
}
